import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-lg-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "fw-bolder" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-left" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cog me-1" }, null, -1)
const _hoisted_9 = { class: "card-body pt-0" }
const _hoisted_10 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_11 = { class: "table align-middle table-row-dashed fs-6 fw-bold gy-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bolder fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, "Beden Seti"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Fiyat"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Sipariş Adedi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Sipariş Tutarı"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Sevk Edilen"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Sevk Tutarı"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-70px text-center" }, "İşlemler")
  ])
], -1)
const _hoisted_13 = {
  key: 0,
  class: "text-gray-600"
}
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-truck" }, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "indicator-label svg-icon svg-icon-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = { class: "text-end" }
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = {
  class: "text-end",
  style: {"padding":"8px"}
}
const _hoisted_35 = { class: "card-flush pt-3 mb-5 mb-lg-10" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#performance-report",
  "aria-expanded": "true",
  "aria-controls": "performance-report"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder" }, "Tarihçe")
  ])
], -1)
const _hoisted_37 = {
  id: "performance-report",
  class: "collapse hide"
}
const _hoisted_38 = { class: "card-body p-9" }
const _hoisted_39 = { class: "p-grid p-fluid" }
const _hoisted_40 = { class: "col-md-12" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-md-12" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Beden Seti"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a card holder's name"
  })
], -1)
const _hoisted_44 = {
  class: "col-md-12",
  style: {"margin-top":"10px"}
}
const _hoisted_45 = { class: "row" }
const _hoisted_46 = {
  class: "col-md-6",
  style: {"border":"1px solid #000","padding":"5px","border-radius":"5px","width":"100%"}
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Fiyat")
], -1)
const _hoisted_48 = { class: "col-md-12" }
const _hoisted_49 = { class: "table-responsive" }
const _hoisted_50 = {
  key: 0,
  class: "table align-middle table-row-dashed fs-6 fw-bold gy-4"
}
const _hoisted_51 = { class: "text-start text-muted fw-bolder fs-7 text-uppercase gs-0" }
const _hoisted_52 = { class: "min-w-40px" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("th", null, "Adet", -1)
const _hoisted_54 = { class: "text-gray-600" }
const _hoisted_55 = { style: {"float":"left","width":"49%"} }
const _hoisted_56 = { class: "p-grid p-fluid" }
const _hoisted_57 = { class: "col-md-12" }
const _hoisted_58 = { class: "row" }
const _hoisted_59 = { class: "col-md-12" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Beden Seti"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Specify a card holder's name"
  })
], -1)
const _hoisted_61 = {
  class: "col-md-12",
  style: {"margin-top":"10px"}
}
const _hoisted_62 = { class: "row" }
const _hoisted_63 = {
  class: "col-md-6",
  style: {"border":"1px solid #000","padding":"5px","border-radius":"5px","width":"100%"}
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold form-label mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Fiyat")
], -1)
const _hoisted_65 = { class: "col-md-12" }
const _hoisted_66 = { class: "table-responsive" }
const _hoisted_67 = { class: "table align-middle table-row-dashed fs-6 fw-bold gy-4" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bolder fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Beden Seti"),
    /*#__PURE__*/_createElementVNode("th", null, "Adet")
  ])
], -1)
const _hoisted_69 = { class: "text-gray-600" }
const _hoisted_70 = { style: {"float":"left","width":"34%"} }

import { ref, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Field } from "vee-validate";
import Modal from "@/components/Modal.vue";
import { useToast } from "primevue/usetoast";
import Shipping from "./Shipping.vue";
import ShippingList from "./ListShipping.vue";
import SizeSetModule from "@/components/sizes/SizeSet.vue";
import Supplier from "@/components/suppliers/SupplierSingleSelect.vue";
import useNotification from "@/components/useNotification";
import DifferenceReason from "@/components/differenceReasons/DifferenceReason.vue";
import Form from "./components/Form.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useRouter, useRoute } from "vue-router";
import JwtService from "@/core/services/JwtService";
//JSON.parse(JwtService.getUser()).roles.find(x => x.id != 2)
import moment from "moment";

export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup(__props) {

const notification = useNotification();
const toast = useToast();
const store = useStore();
const route = useRoute();
const router = useRouter();
const showDetail = ref(false);

store.dispatch(Actions.ORDER_DETAIL, route.params.id).then((f) => {
  if (f.success && f.value != null) {
    showDetail.value = true;
  }
  if (f.value == null) {
    error("Kayıt bulunamadı");
    return;
  }
});
const isActive = ref(false);
const editIsActive = ref(false);
const shippingActive = ref(false);
const sizeSetId = ref();
const orderLinePrice = ref();
const detail = ref();
const sizeRows: any = ref([]);
const shippingDetail: any = ref();
const toggleModal = () => {
  isActive.value = !isActive.value;
  isDisabled.value = false;
  sizeRows.value = [];
  if (!isActive.value) {
    sizeSetId.value = null;
    orderLinePrice.value = null;
  }
};
if (route.params?.sizeSet) {
  isActive.value = true;
}
const editToggleModal = (args) => {
  isDisabled.value = false;
  editIsActive.value = !editIsActive.value;
  sizeRows.value = [];
  if (!editIsActive.value) {
    sizeSetId.value = null;
    orderLinePrice.value = null;
    detail.value = null;
    sizeRows.value = [];
  } else {
    for (let i = 0; i < args.orderDetails.length; i++) {
      sizeRows.value.push({
        id: args.orderDetails[i].size.id,
        count: parseInt(args.orderDetails[i].quantity),
        name: args.orderDetails[i].size.name,
      });
    }
    detail.value = args;
  }
};
const shippingList = (args) => {
  shippingActive.value = !shippingActive.value;
  if (!shippingActive.value) {
    shippingDetail.value = null;
  } else {
    shippingDetail.value = args;
    for (let i = 0; i < args.orderDetails.length; i++) {
      sizeRows.value.push({
        id: args.orderDetails[i].size.id,
        count: parseInt(args.orderDetails[i].quantity),
        name: args.orderDetails[i].size.name,
      });
    }
  }
};
const goBack = () => {
  window.history.length > 1 ? router.go(-1) : router.push("/");
};
onMounted(() => {
  setCurrentPageBreadcrumbs("", ["Sipariş Yönetimi", "Sipariş Ekle"]);
});
store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
const selectedSizeSet = (args) => {
  sizeSetId.value = args.value.value;
  sizeRows.value = [];
  var sizes = getSize.value.filter((f) => f.id == args.value.value)[0].sizes;
  if (detail.value) {
    detail.value.sizeSet.id = args.value.value;
    for (let i = 0; i < sizes.length; i++) {
      var data = detail.value.orderDetails
        .map((f) => {
          return {
            sizeId: f.size.id,
            quantity: f.quantity,
          };
        })
        .find((f) => f.sizeId == sizes[i].id);
      sizeRows.value.push({
        id: sizes[i].id,
        name: sizes[i].name,
        count: data ? parseInt(data.quantity) : 0,
      });
    }
  } else {
    for (let i = 0; i < sizes.length; i++) {
      sizeRows.value.push({ id: sizes[i].id, name: sizes[i].name, count: 0 });
    }
  }
};

const updateOrder = () => {
  console.log("ali");
};
const addOrderLine = () => {
  isDisabled.value = true;
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  var model = {
    orderId: parseInt(route.params.id.toString()),
    sizeSetId: sizeSetId.value,
    currencyTypeId: 1,
    price: parseFloat(orderLinePrice.value.replace(",", ".")),
    sizes: sizeRows.value,
  };
  if (!model.price) {
    error("Fiyat boş olamaz !");
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    isDisabled.value = false;
    return;
  }
  if (model.sizes.map((f) => f.count).filter((f) => f > 0).length == 0) {
    error("En az 1 adet girilmeli!");
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    isDisabled.value = false;
    return;
  }
  store
    .dispatch(Actions.ADD_ORDER_DETAIL, model)
    .then((f) => {
      if (f.success) {
        store.dispatch(Actions.ORDER_DETAIL, route.params.id);
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        notification.showMessage(f.message);
      } else {
        notification.showError("Bir hata oluştu");
        isDisabled.value = false;
        store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      }
    })
    .catch(() => {
      notification.showError("Bir hata oluştu");
      isDisabled.value = false;
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    });
};

const updateOrderLine = () => {
  isDisabled.value = true;
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  var model = {
    id: detail.value.id,
    orderId: parseInt(route.params.id.toString()),
    sizeSetId: detail.value.sizeSet.id,
    currencyTypeId: 1,
    price: parseFloat(detail.value.price.replace(",", ".")),
    sizes: sizeRows.value,
  };
  store.dispatch(Actions.UPDATE_ORDER_DETAIL, model).then((f) => {
    if (f.success) {
      store.dispatch(Actions.ORDER_DETAIL, route.params.id);
      success(f.message);
    } else {
      error(f.message);
    }
  });
};
const removeOrderLine = (args) => {
  Swal.fire({
    title: "İlgili kayıt silinsin mi?",
    text: "Emin misiniz? Bu işlemi geri alamazsınız!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Evet, Sil!",
    cancelButtonText: "İptal",
  }).then((result) => {
    // <--
    if (result.value) {
      // <-- if confirmed
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
      store
        .dispatch(Actions.REMOVE_ORDER_LINE, args.id)
        .then((x) => {
          store.dispatch(Actions.ORDER_DETAIL, route.params.id).then((f) => {
            toast.add({
              severity: "success",
              summary: "İşlem Sonucu",
              detail: x.message,
              life: 3000,
            });
            store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
          });
        })
        .catch((e) => {
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        });
    }
  });
};
const getOrder = computed(() => store.state.OrderModule.order.value);
const getSize = computed(() => store.state.SizeModule.sizeSet.value);
const success = (message) => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  toast.add({
    severity: "success",
    summary: "İşlem Sonucu",
    detail: message,
    life: 3000,
  });
};
const error = (message) => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  toast.add({
    severity: "error",
    summary: "İşlem Sonucu",
    detail: message,
    life: 3000,
  });
};
const selectedDifferenceReason = (args) => {
  console.log(args);
};
const clear = (args) => {
  alert(1);
};
const isDisabled = ref(false);
const focusInFunc = (args) => {
  if (args.count == 0) {
    args.count = undefined;
  }
};
const focusOutFunc = (args) => {
  if (args.count == undefined) {
    args.count = 0;
  }
};

const onKeyup = (event) => {
  const next = event.target.getAttribute("sequence");
  let index = parseInt(next);
  if (
    event.keyCode == 13 ||
    event.keyCode == 81 ||
    event.keyCode == 32 ||
    event.keyCode == 9
  ) {
    document.getElementsByName("orderLinePrice-" + index)[0].select();
    document.getElementsByName("orderLinePrice-" + index)[0].focus();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Timeline = _resolveComponent("Timeline")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, "Sipariş Düzenle - " + _toDisplayString(_unref(route).params.id), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack())),
            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
          }, _hoisted_7),
          _createVNode(_component_router_link, {
            to: '/order/technical-tracking/' + _unref(route).params.id,
            class: "btn btn-sm btn-light-primary me-2"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createTextVNode(" Teknik Takip ")
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (showDetail.value)
          ? (_openBlock(), _createBlock(Form, {
              key: 0,
              data: _unref(store).state.OrderModule.order.value
            }, null, 8, ["data"]))
          : _createCommentVNode("", true),
        (_unref(store).state.OrderModule.order)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (JSON.parse(_unref(JwtService).getUser()).roles.find((x) => x.id != 3))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-light-primary",
                    onClick: toggleModal
                  }, " Sipariş Satırı Oluştur "))
                : _createCommentVNode("", true),
              _createElementVNode("table", _hoisted_11, [
                _hoisted_12,
                (_unref(store).state.OrderModule.order.value)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.OrderModule.order.value
                .orderLines, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "odd",
                          key: index
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.sizeSet.name), 1),
                          _createElementVNode("td", _hoisted_14, _toDisplayString(item.price) + " " + _toDisplayString(item.currency.symbol), 1),
                          _createElementVNode("td", _hoisted_15, _toDisplayString(item.totalQuantity), 1),
                          _createElementVNode("td", _hoisted_16, _toDisplayString(parseFloat(item.totalPrice)
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                    .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(item.currency.symbol), 1),
                          _createElementVNode("td", _hoisted_17, _toDisplayString(item.deliveries
                    .map((f) => f.totalQuantity)
                    .reduce(function (a, b) {
                      return a + b;
                    }, 0)), 1),
                          _createElementVNode("td", _hoisted_18, _toDisplayString(item.deliveries
                    .map((f) => parseFloat(f.totalPrice))
                    .reduce(function (a, b) {
                      return a + b;
                    }, 0)
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                    .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(item.currency.symbol), 1),
                          _createElementVNode("td", _hoisted_19, [
                            _createElementVNode("button", {
                              type: "button",
                              ref_for: true,
                              ref: "removeButtonRef",
                              onClick: ($event: any) => (editToggleModal(item)),
                              class: "btn btn-icon btn-flex btn-active-light-primary w-30px h-30px me-3",
                              "data-bs-toggle": "tooltip",
                              title: "",
                              "data-kt-action": "product_remove",
                              "data-bs-original-title": "Delete"
                            }, _hoisted_22, 8, _hoisted_20),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn btn-icon btn-flex btn-active-light-primary w-30px h-30px me-3",
                              "data-bs-toggle": "tooltip",
                              title: "",
                              onClick: ($event: any) => (shippingList(item))
                            }, _hoisted_25, 8, _hoisted_23),
                            (
                    JSON.parse(_unref(JwtService).getUser()).roles.find(
                      (x) => x.id != 3
                    )
                  )
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  ref_for: true,
                                  ref: "removeButtonRef",
                                  onClick: ($event: any) => (removeOrderLine(item)),
                                  class: "btn btn-icon btn-flex btn-active-light-primary w-30px h-30px me-3",
                                  "data-bs-toggle": "tooltip",
                                  title: "Satır Sil"
                                }, [
                                  _createElementVNode("span", _hoisted_27, [
                                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen027.svg" })
                                  ]),
                                  _hoisted_28
                                ], 8, _hoisted_26))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("tr", null, [
                        _hoisted_29,
                        _hoisted_30,
                        _createElementVNode("td", _hoisted_31, _toDisplayString(_unref(store).state.OrderModule.order.value.orderLines
                    ?.map((f) => f.totalQuantity)
                    .reduce(function (a, b) {
                      return a + b;
                    }, 0)), 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(_unref(store).state.OrderModule.order.value.orderLines
                    ?.map((f) => parseFloat(f.totalPrice))
                    .reduce(function (a, b) {
                      return a + b;
                    }, 0)
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                    .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(_ctx.symbol == null ? "€" : _ctx.symbol), 1),
                        _createElementVNode("td", _hoisted_33, _toDisplayString(_unref(store).state.OrderModule.order.value.orderLines
                    ?.map((f) => f.totalDeliveryQuantity)
                    .reduce(function (a, b) {
                      return a + b;
                    }, 0)), 1),
                        _createElementVNode("td", _hoisted_34, _toDisplayString(_unref(store).state.OrderModule.order.value.orderLines
                    ?.map((f) => parseFloat(f.totalDeliveryPrice))
                    .reduce(function (a, b) {
                      return a + b;
                    }, 0)
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+\.)/g, "$1.")
                    .replace(/\.(\d+)$/, ",$1")) + " " + _toDisplayString(_ctx.symbol == null ? "€" : _ctx.symbol), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_Timeline, {
              value: _unref(getOrder)?.orderHistories,
              align: "alternate"
            }, {
              content: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.item.employeeName) + " - " + _toDisplayString(slotProps.item.operation) + " (" + _toDisplayString(slotProps.item.date) + ") ", 1)
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ])
      ])
    ]),
    _createVNode(Modal, {
      onClose: toggleModal,
      modalActive: isActive.value,
      title: "Sipariş Satırı Ekle",
      width: "75vw"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("b", null, "Toplam Adet : " + _toDisplayString(sizeRows.value
              .map((x) => parseInt(x.count))
              .reduce(function (a, b) {
                return a + b;
              }, 0)), 1)
        ]),
        _createVNode(_component_Button, {
          label: "Kaydet",
          type: "button",
          icon: "pi pi-check",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (addOrderLine())),
          disabled: isDisabled.value
        }, null, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createVNode(SizeSetModule, { onChangeSizeSet: selectedSizeSet })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createVNode(_unref(Field), {
                  type: "text",
                  class: "form-control form-control-solid",
                  name: "orderLinePrice0",
                  modelValue: orderLinePrice.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((orderLinePrice).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  (sizeSetId.value)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_50, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_51, [
                            _createElementVNode("th", _hoisted_52, " Beden Seti " + _toDisplayString(_unref(getSize).filter((f) => f.id == sizeSetId.value)[0].name), 1),
                            _hoisted_53
                          ])
                        ]),
                        _createElementVNode("tbody", _hoisted_54, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSize).filter(
                      (f) => f.id == sizeSetId.value
                    )[0].sizes, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              class: "odd",
                              key: index
                            }, [
                              _createElementVNode("td", null, _toDisplayString(item.name), 1),
                              _createElementVNode("td", null, [
                                (_openBlock(), _createBlock(_unref(Field), {
                                  type: "text",
                                  class: "form-control form-control-solid",
                                  name: 'orderLinePrice0-' + index,
                                  key: index,
                                  modelValue: sizeRows.value[index].count,
                                  "onUpdate:modelValue": ($event: any) => ((sizeRows.value[index].count) = $event),
                                  onKeyup: onKeyup,
                                  sequence: index,
                                  onFocus: ($event: any) => (focusInFunc(sizeRows.value[index])),
                                  onFocusout: ($event: any) => (focusOutFunc(sizeRows.value[index]))
                                }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "sequence", "onFocus", "onFocusout"]))
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modalActive"]),
    _createVNode(Modal, {
      onClose: editToggleModal,
      modalActive: editIsActive.value,
      title: "Sipariş Detayı Düzenle",
      width: "75vw"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("b", null, "Toplam Adet : " + _toDisplayString(sizeRows.value
              .map((x) => parseInt(x.count))
              .reduce(function (a, b) {
                return a + b;
              }, 0)), 1)
        ]),
        (JSON.parse(_unref(JwtService).getUser()).roles.find((x) => x.id != 3))
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: "Güncelle",
              type: "button",
              icon: "pi pi-check",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (updateOrderLine())),
              disabled: isDisabled.value
            }, null, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createVNode(SizeSetModule, {
                  onChangeSizeSet: selectedSizeSet,
                  data: detail.value.sizeSet,
                  disabled: true
                }, null, 8, ["data"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _hoisted_64,
                _createVNode(_unref(Field), {
                  type: "text",
                  class: "form-control form-control-solid",
                  name: "orderLinePrice",
                  tabindex: "-1",
                  modelValue: detail.value.price,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((detail.value.price) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("table", _hoisted_67, [
                    _hoisted_68,
                    _createElementVNode("tbody", _hoisted_69, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sizeRows.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "odd",
                          key: index
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.name), 1),
                          _createElementVNode("td", null, [
                            (_openBlock(), _createBlock(_unref(Field), {
                              type: "text",
                              class: "form-control form-control-solid",
                              name: 'orderLinePrice-' + index,
                              onKeyup: onKeyup,
                              tabIndex: index,
                              sequence: index,
                              onFocus: ($event: any) => (focusInFunc(sizeRows.value[index])),
                              onFocusout: ($event: any) => (focusOutFunc(sizeRows.value[index])),
                              key: index,
                              modelValue: sizeRows.value[index].count,
                              "onUpdate:modelValue": ($event: any) => ((sizeRows.value[index].count) = $event)
                            }, null, 8, ["name", "tabIndex", "sequence", "onFocus", "onFocusout", "modelValue", "onUpdate:modelValue"]))
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modalActive"]),
    (shippingActive.value)
      ? (_openBlock(), _createBlock(ShippingList, {
          key: 0,
          isActive: shippingActive.value,
          id: 1,
          name: _ctx.ali,
          onChangeReceipt: shippingList,
          data: shippingDetail.value,
          sizeRows: sizeRows.value,
          onChangeDate: _ctx.changeDate
        }, null, 8, ["isActive", "name", "data", "sizeRows", "onChangeDate"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})